import { eAtlas, eAtlasFrame, eUIAtlasFrame, Game } from "./Game";

export const enum eSprite {
    cameraFlash,
    hitFx,
    btnResOK,
}



export class SpriteDsc {
    get name(): string { return this._name; }
    private _name: string;

    get atlas(): eAtlas { return this._atlas; }
    private _atlas: eAtlas;

    get frameKeys(): string[] { return this._frameKeys; }
    private _frameKeys: string[];

    get pixelsPerUnit(): number { return this._pixelsPerUnit; }
    private _pixelsPerUnit: number;

    private _assetId: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(name: string, atlas: eAtlas, frameKey: string, frameCnt: number, pixelsPerUnit: number = 100) {
        this._name = name;
        this._atlas = atlas;
        this._frameKeys = [];

        for (let i = 0; i < frameCnt; i++)
            this._frameKeys.push(frameKey + i);

        this._pixelsPerUnit = pixelsPerUnit;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    getSpriteAssetId(): number {
        if (this._assetId == undefined)
            this._assetId = Game.app.assets.find(this._name, pc.eAssetType.sprite).id;

        return this._assetId;
    }
}



export const SPRITES: SpriteDsc[] = [
    new SpriteDsc("flash", eAtlas.fx1, "cameraFlash/", 5, 50),
    new SpriteDsc("hitFx", eAtlas.def1, eAtlasFrame.hitFx, 13, 100),
    new SpriteDsc("btnResOK", eAtlas.ui, eUIAtlasFrame.resBtnOK, 1, 100),
];